import React from "react";

export default function SectionHeading({ eyebrow, title, subtitle, align = "left", light = false }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <div className={align === "center" ? "flex justify-center" : ""}>
          <span className={`inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] mb-3 ${light ? "text-teal-light" : "text-teal"}`}>
            <span className="w-6 h-px bg-current" />
            {eyebrow}
          </span>
        </div>
      )}
      <h2 className={`text-3xl md:text-4xl lg:text-[40px] font-bold tracking-tight leading-[1.15] ${light ? "text-white" : "text-navy"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-[17px] leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
